export const defaultTags = [
  { label: "Personal", value: "personal" },
  { label: "Gold", value: "gold" },
  { label: "EMI", value: "emi" },
  { label: "CC Limit", value: "cc-limit" }
];